import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router";
import React, { Suspense, lazy, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "./DolphinCareLibrary/DCL.scss";
import "./app.scss";
import "./index.scss";
import LoadingPage from "./DolphinCareLibrary/LoadingPage";

// import { getCategories } from './redux/globalfunctions';
import { useSelector } from "react-redux";

// Each route surface loads as its own chunk so a user only downloads the
// screens they visit (nurses never pay for the admin/metrics bundle).
const RegisterForm = lazy(() => import("./UserPages/RegisterForm"));
const Client = lazy(() => import("./Client"));
const MainMetrics = lazy(() => import("./MetricPages/MainMetrics"));
const PrivacyPolicy = lazy(() => import("./UserPages/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("./UserPages/TermsOfUse"));
const QaDashboard = lazy(() => import("./QaDashboard"));
const Document = lazy(() => import("./UserInterface/Document"));
const AssistantPanel = lazy(
  () => import("./UserInterface/Assistant/AssistantPanel"),
);
const FacilityAssistantPanel = lazy(
  () => import("./UserInterface/Assistant/FacilityAssistantPanel"),
);

const App = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const routerLocation = useLocation();
  const routerNavigate = useNavigate();
  // const dispatch = useDispatch()
  const loading = useSelector((state) => state.globalState.isLoading);

  useEffect(() => {
    setTokens();
    // navigate(routerLocation.pathname, { replace: true })
    if (routerLocation.pathname.includes("//"))
      window.location.href = routerLocation.pathname.replace(/\/+/g, "/");
    if (routerLocation.pathname === "/" || routerLocation.pathname === "")
      routerNavigate(
        window.location.hostname.includes("internal") ? "admin" : "client",
      );

    // dispatch(getCategories());
  }, []);

  const setTokens = () => {
    const dcToken = searchParams.get("dc_token");
    if (dcToken) {
      window.localStorage.setItem("dc_token", dcToken);
      searchParams.delete("dc_token");
    }
    const appToken = searchParams.get("dc_app_token");
    if (appToken) {
      window.localStorage.setItem("dc_token", appToken);
      searchParams.delete("dc_app_token");
    }
    const dcBrowser = searchParams.get("dc_browser");
    if (dcBrowser) {
      window.localStorage.setItem("dc_browser", dcBrowser);
      searchParams.delete("dc_browser");
    }
    setSearchParams(searchParams);
  };

  return (
    <>
      {loading && <LoadingPage />}
      <Suspense fallback={<LoadingPage />}>
        <Routes>
          <Route
            exact
            path="/"
            element={
              <Navigate
                to={
                  window.location.hostname.includes("internal")
                    ? "/admin"
                    : "/client"
                }
              />
            }
          />
          <Route
            exact
            path=""
            element={
              <Navigate
                to={
                  window.location.hostname.includes("internal")
                    ? "/admin"
                    : "/client"
                }
              />
            }
          />
          <Route path="/metrics/*" element={<MainMetrics />} />
          <Route path="/client/*" element={<Client idle={props.idle} />} />
          <Route path="/document/:type/:id" element={<Document />} />
          <Route path="/document/:type/:id/:group" element={<Document />} />
          {/* v1: embedded-in-PCC assistant surface (identity from route params; ard via ?ard=) */}
          <Route
            path="/assistant/:group/:facility/:client_id/:mrn"
            element={<AssistantPanel />}
          />

          {/* Facility-mode (roster-wide) assistant — no resident; group +
              facility only. Mirrors the API: dropping the resident segments is
              what selects facility mode. */}
          <Route
            path="/assistant/:group/:facility"
            element={<FacilityAssistantPanel />}
          />

          <Route path="/qadashboard" element={<QaDashboard />} />

          <Route path="/register" element={<RegisterForm />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/termsofuse" element={<TermsOfUse />} />
          <Route
            path="/"
            element={
              <Navigate
                to={
                  window.location.hostname.includes("internal")
                    ? "/admin"
                    : "/client"
                }
              />
            }
          />
        </Routes>
      </Suspense>
    </>
  );
};

export default App;
